import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { roleid, token } from "../Actions/AuthAction";
import { listDrive } from "../Actions/DriveAction";
import Shimmer from "../Common/Shimmer";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Loader from "../Common/Loader";
import { getInstituteList } from "../Actions/AdminAction";
const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};
export const DriveList = () => {
  const [page, setpage] = useState(1);
  const [totaldrive, settotaldrive] = useState(0);
  const [driveList, setdriveList] = useState(null);
  const [userrole, setuserrole] = useState(null);
  const [drivestartdate, setdrivestartdate] = useState("");
  const [driveenddate, setdriveenddate] = useState("");
  const [loading, setLoading] = useState(false);
  const [instituteOptions, setinstituterOptions] = useState([]);
  const [instituteid, setinstituteid] = useState("");

  const [venuestatus, setVenueStatus] = useState("");
  const [drivetype, setDriveType] = useState("");
  const [drivestatus, setDriveStatus] = useState("");

  const form = useRef(null);

  useEffect(() => {
    setLoading(true);
    const model = {
      loginusertoken: token(),
      page: page,
      startdate: drivestartdate,
      enddate: driveenddate,
      instid: instituteid,
      venuestatus: venuestatus,
      drivetype: drivetype,
      drivestatus: drivestatus,
    };
    getDrive(model);
    setuserrole(roleid());
    getInstituteList({
      key: token(),
      page: "1",
      search: "",
      status: "",
      city: "",
      state: "",
      limit: 500,
    }).then((res) => {
      setinstituterOptions(res.data);
    });
  }, []);

  const renderDrive = () => {
    return (
      <>
        {driveList.map((item, index) => (
          <div className="card formcard mb-3" key={index}>
            <div className="card-body">
              <div className="d-flex justify-content-between pb-2 border-bottom">
                <div className="d-flex justify-content-start">
                  {/* <img
                      src={
                        item.jobdrivejobmaps && item.jobdrivejobmaps.length != 0
                          ? item.jobdrivejobmaps[0].job.employee.logo
                          : "data:image/png;base64,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"
                      }
                      className="company_logo"
                    /> */}
                  <div className="ml-3">
                    <h4 className="mb-0">
                      <Link to={`/drivedetail/${item.driveid}`}>
                        {item.drivename}
                      </Link>
                    </h4>
                  </div>
                  <div></div>
                </div>
                <div className="header-btn">
                  {!(userrole == 5) ? (
                    <Link
                      to={`/DriveSelectedCandidate/${item.driveid}`}
                      className="btn btn-primary-custom mx-2 d-block mb-2"
                    >
                      <i class="fas fa-list"></i> Selected Candidates
                    </Link>
                  ) : null}
                  {/* {item.institutestatus == 1 ? <a className="btn btn-secondary-custom mx-2 d-block mb-2" href="#">Not Verified</a> :
                item.institutestatus == 2 ? <a className="btn btn-secondary-custom mx-2 d-block mb-2" href="#">Verified</a> :
                  <a className="btn btn-secondary-custom mx-2 d-block mb-2" href="#">Rejected</a>} */}
                </div>
              </div>
              <div className="d-flex justify-content-between pt-3 joblisting">
                <div className="col-md-4">
                  <ul className="font-weight-bold">
                    <li>Drive Id:</li>
                    <li>Drive Start Date:</li>
                    <li>Drive End Date:</li>
                    <li>Consulting Partner/Institution:</li>
                  </ul>
                </div>
                <div className="col-md-8">
                  <ul>
                    <li>
                      #{item.driveid}{" "}
                      {item.drivestatus == 2 ? (
                        <span className="badge badge-pill badge-success mx-1 p-1 my-1">
                          Open
                        </span>
                      ) : (
                        <span className="badge badge-pill badge-danger mx-1 p-1 my-1">
                          Closed
                        </span>
                      )}
                      {item.drivetype == 1 ? (
                        <span className="badge badge-pill badge-warning mx-1 p-1 my-1">
                          Single
                        </span>
                      ) : (
                        <span className="badge badge-pill badge-dark mx-1 p-1 my-1">
                          Pool
                        </span>
                      )}
                    </li>
                    <li>{item.drivestartdate}</li>
                    <li>{item.driveenddate}</li>
                    <li>
                      {item.jobdriveinstmaps.map((item, key) => (
                        <>
                          <span className="badge badge-pill badge-info mx-1 p-2 my-1">
                            {/* <img src={item.institute.logo} className="institute_logo" />  */}
                            {item.institute.name}
                          </span>{" "}
                        </>
                      ))}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ))}
      </>
    );
  };

  const getDrive = (model) => {
    listDrive(model).then((res) => {
      settotaldrive(res.totaldata);
      setdriveList(res.data);
      setLoading(false);
    });
  };

  const changePage = (value) => {
    setLoading(true);
    const truePage = page + value;
    setpage(page + value);
    window.scroll(0, 0);
    setdriveList(null);

    const model = {
      page: truePage,
      loginusertoken: token(),
      startdate: drivestartdate,
      enddate: driveenddate,
      instid: instituteid,
      venuestatus: venuestatus,
      drivetype: drivetype,
      drivestatus: drivestatus,
    };
    getDrive(model);
  };

  const setInstitute = (value) => {
    setLoading(true);
    window.scroll(0, 0);
    getDrive(null);
    const model = {
      page: 1,
      loginusertoken: token(),
      startdate: drivestartdate,
      enddate: driveenddate,
      instid: value,
      venuestatus: venuestatus,
      drivetype: drivetype,
      drivestatus: drivestatus,
    };
    setinstituteid(value);
    getDrive(model);
  };

  const DriveType = (value) => {
    setLoading(true);
    window.scroll(0, 0);
    getDrive(null);
    const model = {
      page: 1,
      loginusertoken: token(),
      startdate: drivestartdate,
      enddate: driveenddate,
      instid: instituteid,
      venuestatus: venuestatus,
      drivetype: value,
      drivestatus: drivestatus,
    };
    setDriveType(value);
    getDrive(model);
  };

  const DriveStatus = (value) => {
    setLoading(true);
    window.scroll(0, 0);
    getDrive(null);
    const model = {
      page: 1,
      loginusertoken: token(),
      startdate: drivestartdate,
      enddate: driveenddate,
      instid: instituteid,
      venuestatus: venuestatus,
      drivetype: drivetype,
      drivestatus: value,
    };
    setDriveStatus(value);
    getDrive(model);
  };

  const DriveStartDate = (value) => {
    setLoading(true);
    window.scroll(0, 0);
    getDrive(null);
    const model = {
      page: 1,
      loginusertoken: token(),
      startdate: value,
      enddate: driveenddate,
      instid: instituteid,
      venuestatus: venuestatus,
      drivetype: drivetype,
      drivestatus: drivestatus,
    };
    setdrivestartdate(value);
    getDrive(model);
  };

  const DriveEndDate = (value) => {
    setLoading(true);
    window.scroll(0, 0);
    getDrive(null);
    const model = {
      page: 1,
      loginusertoken: token(),
      startdate: drivestartdate,
      enddate: value,
      instid: instituteid,
      venuestatus: venuestatus,
      drivetype: drivetype,
      drivestatus: drivestatus,
    };
    setdriveenddate(value);
    getDrive(model);
  };

  const to = (page - 1) * 5 + 1;
  const from = page * 5 > totaldrive ? totaldrive : page * 5;
  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="row mb-4">
        <div className="col-md-12">
          <h4 className="table_heading position-relative">DRIVE LIST</h4>
        </div>
      </div>
      <div className="d-flex justify-content-between">
        <p className="text-black font-weight-bold">
          {totaldrive} Campus Drives
        </p>
        <p className="text-secondary">
          Drives {to} to {from} of {totaldrive}
        </p>
      </div>
      <div className="row">
        <div className="col-md-3 order-sm-12">
          <div className="card formcard p-2">
            <p className="text-black font-weight-bold table_heading position-relative">
              Filter
            </p>
            <Form ref={form} className="form-group">
              <div className="form-group col-md-12">
                <label className="mb-1" for="inputEmailAddress">
                  Drive Type
                </label>
                <select
                  className="form-control rounded-pill"
                  onChange={(e) => DriveType(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="1">Single</option>
                  <option value="2">Pool</option>
                </select>
              </div>

              <div className="form-group col-md-12">
                <label className="mb-1" for="inputEmailAddress">
                  Drive Status
                </label>
                <select
                  className="form-control rounded-pill"
                  onChange={(e) => DriveStatus(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="2">Open</option>
                  <option value="1">Closed</option>
                </select>
              </div>

              {roleid() != 2 ? (
                <div className="form-group col-md-12">
                  <label className="mb-1" for="inputEmailAddress">
                    Consulting Partner/Institution
                  </label>
                  <select
                    title="Select Company"
                    className="form-control rounded-pill"
                    onChange={(e) => setInstitute(e.target.value)}
                  >
                    <option value="">
                      Select Consulting Partner/Institution
                    </option>
                    {instituteOptions.map((item) => (
                      <option
                        value={item.id}
                        style={{ backgroundImage: `url(${item.logo})` }}
                      >
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              ) : null}

              <div className="form-group col-md-12">
                <label className="mb-1" for="inputEmailAddress">
                  Start Date
                </label>
                <Input
                  validations={[required]}
                  type="datetime-local"
                  className="form-control rounded-pill"
                  value={drivestartdate}
                  onChange={(e) => DriveStartDate(e.target.value)}
                />
              </div>
              <div className="form-group col-md-12">
                <label className="mb-1" for="inputEmailAddress">
                  End Date
                </label>

                <Input
                  validations={[required]}
                  type="datetime-local"
                  min={drivestartdate}
                  className="form-control rounded-pill"
                  value={driveenddate}
                  onChange={(e) => DriveEndDate(e.target.value)}
                />
              </div>

              {/* <div className="form-group col-md-12">
                <button className="btn btn-primary-custom mr-1">Apply</button>
                <button className="btn btn-secondary-custom">Reset</button>
              </div> */}
            </Form>
          </div>
        </div>
        <div className="col-md-9 order-sm-1">
          {" "}
          {/* {jobList?renderJob():<Shimmer/>} */}
          {driveList ? renderDrive() : <></>}
          <ul className="d-flex justify-content-between list-unstyled pagination">
            <li className="px-3">
              {page == 1 ? (
                <a className="d-none">
                  <i className="fa fa-arrow-left" aria-hidden="true"></i> PREV
                </a>
              ) : (
                <a onClick={(e) => changePage(-1)}>
                  <i className="fa fa-arrow-left" aria-hidden="true"></i> PREV
                </a>
              )}
            </li>

            <li className="px-3">
              {driveList && driveList.length < 5 ? (
                <a className="d-none">
                  {" "}
                  <i className="fa fa-arrow-right" aria-hidden="true"></i>
                  NEXT
                </a>
              ) : (
                <a onClick={(e) => changePage(1)}>
                  {" "}
                  <i className="fa fa-arrow-right" aria-hidden="true"></i>
                  NEXT
                </a>
              )}
            </li>
          </ul>
        </div>


      </div>


    </React.Fragment>
  );
};
